import React, { useEffect, useState } from 'react';
import { Wizard } from './setup/Wizard';
import { SettingsDashboard } from './setup/SettingsDashboard';
import { useNavigate } from 'react-router-dom';
export function Setup() {
  const [isWizard, setIsWizard] = useState(true);
  const navigate = useNavigate();
  useEffect(() => {
    const completed = localStorage.getItem('setup_completed');
    if (completed === 'true') {
      setIsWizard(false);
    }
  }, []);
  const handleComplete = () => {
    localStorage.setItem('setup_completed', 'true');
    navigate('/');
  };
  const handleRunWizard = () => {
    setIsWizard(true);
  };
  return <div className="min-h-screen" data-id="element-3221">
      {isWizard ? <Wizard onComplete={handleComplete} data-id="element-3222" /> : <SettingsDashboard onRunWizard={handleRunWizard} data-id="element-3223" />}
    </div>;
}